export default __webpack_public_path__ + "static/media/birdDown.76046fd0.svg";